import { render, staticRenderFns } from "./FutureDiscount.vue?vue&type=template&id=47a61fd0&scoped=true&"
import script from "./FutureDiscount.vue?vue&type=script&lang=js&"
export * from "./FutureDiscount.vue?vue&type=script&lang=js&"
import style0 from "./FutureDiscount.vue?vue&type=style&index=0&id=47a61fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a61fd0",
  null
  
)

component.options.__file = "FutureDiscount.vue"
export default component.exports